// @flow
import React, { useEffect, useState } from 'react';
import moment from 'moment';
import { withFlux } from '@homie/flux';
import { withRouter } from 'react-router-dom';
import { get } from 'lodash';
import swal from 'sweetalert2';
import TenantReportStore from 'modules/external_tenant/api/stores/TenantReportStore';
import TenantReportActions from 'modules/external_tenant/api/actions/TenantReportActions';
import ScoreFunction from 'components/homes/ownership/Functions/ScoreFunction';
import ScoreRangeBar from 'components/shared/ScoreRangeBar';
import ModalSuccessProcessComponent from 'modules/external_tenant/components/ModalSuccessProcessComponent';
import {
  TenantReportContainer,
  TenantReportContainerInner,
  TenantReportHeading,
  ValidThrough,
  Paragraph,
  TenantActionContainer,
  EvaluationResult,
  PriceOptions,
  SuccessOverlay,
  Circle,
  Icon,
  OverlayHead,
  OverlayMessage,
  SendWhatsAppBtn,
  Wrapper,
  AutomateCheckContainer,
  StyledValidatedCheckbox,
  ContainterBox,
  LabelBox,
  StylesSelect
} from './styles';
import CheckBox from 'components/CheckboxComponent';
import { ReactSelectCardSaved } from 'styles/Select';
type SelectElement = {
  value: number,
  label: string
};

type TenantReportProps = {
  match: any,
  showProcessLoading: (msg: string) => null,
  hideProcessLoading: () => null,
  report: any,
  history: any
};

const TenantReport = ({
  match,
  showProcessLoading,
  hideProcessLoading,
  report,
  history
}: TenantReportProps) => {
  const isTenantApproved = get(report, 'homie_score', 0) > 580;
  const [showModal, setShowModal] = useState(false);
  const [
    depositPartializationAccepted,
    setDepositPartializationAccepted
  ] = useState(false);
  const [monthsPayDeposit, setMonthsPayDeposit] = useState(null);
  const monthOptions = [{ value: 6, label: '6 meses' }];

  const isMobile = window.innerWidth < 768;

  const { userId, homeApplicationId, token } = match.params;
  useEffect(() => {
    showProcessLoading('Cargando reporte...');
    TenantReportActions.fetchTenantReport(userId, homeApplicationId, token)
      .then(() => {
        hideProcessLoading();
      })
      .catch(e => {
        hideProcessLoading();
        history.push('/inquilinos-externos/proceso-completado');
      });
  }, []);

  const sendToOwner = () => {
    showProcessLoading('Cargando reporte...');
    let MSI = null;
    if (get(report, 'allow_monthly_owner_deposit_payment'))
      MSI = {
        allow_monthly_owner_deposit_payment: depositPartializationAccepted,
        months_to_pay_rent_deposit: monthsPayDeposit
      };
    TenantReportActions.sendWhatsapp(homeApplicationId, MSI)
      .then(() => {
        hideProcessLoading();
        setShowModal(true);
      })
      .catch(e => {
        hideProcessLoading();
        swal({
          title: '¡Ha ocurrido un error!',
          text:
            (e.responseJson && e.responseJSON.message) ||
            'Ocurrió un error desconocido mientras se enviaban los datos del reporte',
          type: 'error'
        });
      });
  };

  const closeOverlay = () => {
    setShowModal(false);
    history.push('/inquilinos-externos/proceso-completado');
  };

  const handleInputChange = () => {
    const newValueDepositPartializationAccepted = !depositPartializationAccepted;
    setDepositPartializationAccepted(newValueDepositPartializationAccepted);
    setMonthsPayDeposit(null);
    if (newValueDepositPartializationAccepted)
      setMonthsPayDeposit(monthOptions[0].value);
  };

  const onOptionSelected = (selectElement: SelectElement) => {
    setMonthsPayDeposit(selectElement.value);
  };

  return (
    <React.Fragment>
      {showModal && !isMobile && (
        <React.Fragment>
          <SuccessOverlay></SuccessOverlay>
          <ModalSuccessProcessComponent
            autoClose
            timerClose={5000}
            handleCloseModal={closeOverlay}
            show
            message="Hemos envíado tu reporte al propietario del departamento que deseas, te deseamos mucha suerte para que el dueño del depa te acepte"
          />
        </React.Fragment>
      )}
      {showModal && isMobile && (
        <SuccessOverlay>
          <Circle>
            <Icon>👍</Icon>
          </Circle>
          <OverlayHead>¡Listo!</OverlayHead>
          <OverlayMessage>
            Hemos envíado tu reporte al propietario del departamento que deseas,
            te deseamos mucha suerte para que el dueño del depa te acepte
          </OverlayMessage>
          <SendWhatsAppBtn onClick={closeOverlay}>Cerrar</SendWhatsAppBtn>
        </SuccessOverlay>
      )}
      {!showModal && (
        <React.Fragment>
          <TenantReportContainer>
            <TenantReportContainerInner>
              <TenantReportHeading>Reporte de inquilino</TenantReportHeading>
              <ValidThrough>
                Fecha:{' '}
                {moment(
                  get(report, 'home_application_resolved_at', new Date())
                ).format('MMM DD')}{' '}
                - Válido hasta:{' '}
                {moment(
                  get(report, 'home_application_expires_at', new Date())
                ).format('DD MMMM YYYY')}
              </ValidThrough>
              <Paragraph>
                Calculado con Homie Technology que tiene un{' '}
                <strong>rango de 0 a 1500</strong>
              </Paragraph>
              <ScoreFunction
                score={get(report, 'homie_score', 0)}
                size={156}
                fontSize={48}
                color={isTenantApproved ? '#48c16a' : '#ff0000'}
              />
              <ScoreRangeBar
                width={300}
                barHeight={10}
                limitsFontSize={20}
                labelsFontSize={12}
                failed={!isTenantApproved}
              />
              {isTenantApproved && (
                <TenantReportHeading>
                  Este puntaje es excelente
                </TenantReportHeading>
              )}
              {!isTenantApproved && (
                <TenantReportHeading>
                  Este puntaje no es suficiente
                </TenantReportHeading>
              )}
              <Paragraph>
                Rango {isTenantApproved ? 'superior' : 'menor'} a 22% de los
                Inquilinos de México
              </Paragraph>
              {get(report, 'allow_monthly_owner_deposit_payment') && (
                <Wrapper>
                  <AutomateCheckContainer>
                    <StyledValidatedCheckbox>
                      <ContainterBox>
                        <CheckBox
                          checked={depositPartializationAccepted}
                          value={depositPartializationAccepted}
                          onChange={handleInputChange}
                        />
                      </ContainterBox>
                      <LabelBox>
                        Quiero generar mi depósito a meses sin intereses
                      </LabelBox>
                    </StyledValidatedCheckbox>
                  </AutomateCheckContainer>
                  {depositPartializationAccepted && (
                    <StylesSelect
                      options={monthOptions}
                      onChange={onOptionSelected}
                      searchable={false}
                      styles={ReactSelectCardSaved}
                      defaultValue={monthOptions[0]}
                    />
                  )}
                </Wrapper>
              )}
            </TenantReportContainerInner>
          </TenantReportContainer>
          <TenantActionContainer approved={isTenantApproved}>
            {isTenantApproved && (
              <EvaluationResult>
                Eres inquilino avalado por Homie, cuéntaselo al propietario del
                depa y pronto podrás comenzar a rentarlo
              </EvaluationResult>
            )}
            {!isTenantApproved && (
              <EvaluationResult>
                El puntaje obtenido no es el suficiente para este depa, pero
                puedes encontrar uno en <a href="/">homie.mx</a>
              </EvaluationResult>
            )}
            {isTenantApproved && (
              <SendWhatsAppBtn style={{ width: 290 }} onClick={sendToOwner}>
                Enviar mi acreditación por whatsapp
              </SendWhatsAppBtn>
            )}
            {!isTenantApproved && (
              <PriceOptions>
                Desde: $5,000 MXN - Hasta: $12,000 MXN
              </PriceOptions>
            )}
          </TenantActionContainer>
        </React.Fragment>
      )}
    </React.Fragment>
  );
};

export default withFlux([TenantReportStore], () => ({
  report: TenantReportStore.getReport()
}))(withRouter(TenantReport));
